<template>
    <div class="reconciliation-filter">
        <div class="reconciliation-filter__row">
            <BaseTabList
                v-if="isBaseTabList"
                :isLoading="isLoading"
                :tabList="tabList"
                :tabIdActive="tabIdActive"
                :theme="'filter-outline'"
                :size="'small'"
                class="reconciliation-filter__base-tab-list"
                @update:tabIdActive="onChangeTab"
            />
    
            <PriceFiltersList
                :isLoading="isLoading"
                :scheme="filterItems"
                :selected="filterSelectedDataMap"
                @apply="onApplyFilter"
            />
        </div>

        <div
            v-if="filterItemsChips.length"
            class="reconciliation-filter__row"
        >
            <Chips 
                :chips="filterItemsChips"
                :numberDisplayedChips="0"
                :isRemoveAll="isRemoveAllChips"
                :isRemoveAllIcon="true"
                @remove="onRemoveFilterChipItem"
                @onRemoveAllChips="onRemoveAllFilterChips"
            />
        </div>
    </div>
</template>

<script>
import BaseTabList from '@/components/Base/BaseTabList.vue';
import PriceFiltersList from "@/components/pages/price/PriceFiltersList.vue";
import Chips from "@/layouts/components/Chips.vue";

export default {
    name: "ReconciliationFilterV2",
    components: {
        BaseTabList,
        PriceFiltersList,
        Chips
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
        isBaseTabList: {
            type: Boolean,
            default: false
        },
        tabList: {
            type: Array,
            default: () => ([])
        },
        tabIdActive: {
            type: String,
            default: ""
        },
        filterItems: {
            type: Array,
            default: () => ([])
        }
    },
    computed: {
        filterSelectedDataMap() {
            return this.filterItems.reduce((filterSelectedDataMap, filterItem) => {
                const { id: filterItemId = "", valuesSelected = [] } = filterItem;
                filterSelectedDataMap[filterItemId] = [...valuesSelected];

                return filterSelectedDataMap;
            }, {});
        },
        filterItemsChips() {
            const filterItemsChips = this.filterItems.reduce((filterItemsChips, filterItem) => {
                const {
                    values = [],
                    valuesSelected = [],
                    id: filterItemId = "",
                } = filterItem;

                if (valuesSelected.length > 0) {
                    const valuesSelectedChips = valuesSelected.map(valueSelected => {
                        const value = values.find(value => value.id === valueSelected);
                        const valueSelectedChips = {
                            ...value,
                            filterItemId: filterItemId,
                        };

                        return valueSelectedChips;
                    });

                    filterItemsChips.push(...valuesSelectedChips);
                }

                return filterItemsChips;
            }, []);

            return filterItemsChips;
        },
        isRemoveAllChips() {
            return this.filterItemsChips.length >= 2;
        },
    },
    methods: {
        onChangeTab(tabIdActive) {
            this.$emit('changeTab', tabIdActive);
        },
        onApplyFilter({ value: filterComponentItems = [], key: filterItemId = "" }) {
            this.$emit('applyFilter', filterComponentItems, filterItemId);
        },
        onRemoveFilterChipItem(chipItem = {}) {
            const { filterItemId = "", id = "" } = chipItem;
            const filterItem = this.filterItems.find(filterItem => filterItem.id === filterItemId) ?? {};
            let { valuesSelected = [] } = filterItem;
            const valueSelectedIndex = valuesSelected.findIndex((value) => value === id);
            
            if (valueSelectedIndex !== -1) {
                valuesSelected.splice(valueSelectedIndex, 1);
                this.onApplyFilter(valuesSelected, filterItemId);
            }
        },
        onRemoveAllFilterChips() {
            const filterItemsNew = this.filterItems.map((filterItem) => {
                filterItem.valuesSelected = [];

                return filterItem;
            });

            this.$emit("removeAllFilterChips", filterItemsNew);
        },
    },
};
</script>

<style lang="scss" scoped>
.reconciliation-filter {
    &__row {
        display: flex;

        &:not(:last-child) {
            margin-bottom: 12px;
        }
    }

    &__base-tab-list {
        margin-right: 20px;
        width: fit-content;
        min-width: 320px;
    }
}
</style>